import { createSelector } from '@reduxjs/toolkit';
import { selfPixelsSelector } from './self';

const pixelsSelector = createSelector(selfPixelsSelector, (pixels) => pixels.pixels);

export default pixelsSelector;
